// @flow
import { Map }                                                      from 'immutable';
import { Reducer }                                                  from '../../Reducer';
import { simpleOnGetFail, simpleOnGetRequest, simpleOnGetSuccess, } from '../../utils';
import * as TYPES                                                   from './types';

const DEFAULT_STATE = Map({
    busy:  false,
    error: null,
    items: [],
    item:  null,
});

export default class SkuGendersReducer extends Reducer {
    NAME = 'SkuGenders';

    alias = {
        [ TYPES.SKU_GENDERS_GET_REQUEST ]: 'onGetRequest',
        [ TYPES.SKU_GENDERS_GET_SUCCESS ]: 'onGetSuccess',
        [ TYPES.SKU_GENDERS_GET_FAIL ]:    'onGetFailure',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = simpleOnGetSuccess(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetFailure = simpleOnGetFail(DEFAULT_STATE);

}
